import * as React from 'react';
import * as moment from 'moment';

const days = ['Ne', 'Po', 'Ut', 'St', 'Ct', "Pa", 'So'];

// yyyy-MM-dd
export function toModalDate(date) {
    if (!date)
        return '';
    date = toDate(date);

    let month = `${date.getMonth() + 1}`.padStart(2, '0');
    let day = `${date.getDate()}`.padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
}

// yyyy-MM
export function toPeriodDate(date) {
    if (!date)
        return '';
    date = toDate(date);

    let month = `${date.getMonth() + 1}`.padStart(2, '0');
    return `${date.getFullYear()}-${month}`;
}

// ddd d. M. yyyy
export function toLunchDate(date) {
    if (!date)
        return '';
    date = toDate(date);

    return `${days[date.getDay()]} ${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;
}

// Date
export function toDate(date) {
    if (!date)
        return null;
    if (typeof date === 'string')
        date = parseDate(date);
    if (typeof date === 'number')
        date = new Date(date);

    return date;
}

export function parseDate(dateString) {
    // let delta = Date.parse('2019-09-02T00:00:00') - 1567375200000;
    // let result = Date.parse(dateString) - delta;
    let result = moment(dateString).toDate().getTime();
    // console.log('parseDate', { date: result, moment: moment(dateString).toDate().getTime() });
    return result;
}

// d. M.
export function toLunchShortDate(date) {
    if (!date)
        return '';
    date = toDate(date);

    return `${date.getDate()}. ${date.getMonth() + 1}.`;
}

// ddd
export function toLunchDay(date) {
    if (!date)
        return '';
    date = toDate(date);

    return days[date.getDay()];
}

// yyyy-MM-dd HH-mm
export function toModalDateTime(dt) {
    if (!dt)
        return '';
    dt = toDate(dt);

    let month = `${dt.getMonth() + 1}`.padStart(2, '0');
    let day = `${dt.getDate()}`.padStart(2, '0');
    let hour = `${dt.getHours()}`.padStart(2, '0');
    let min = `${dt.getMinutes()}`.padStart(2, '0');
    return `${dt.getFullYear()}-${month}-${day} ${hour}:${min}`;
}

// d. M. yyyy  HH:mm
export function toPaymentDateTime(dt) {
    if (!dt)
        return '';
    dt = toDate(dt);

    let hour = `${dt.getHours()}`.padStart(2, '0');
    let min = `${dt.getMinutes()}`.padStart(2, '0');
    return <span>{`${dt.getDate()}. ${dt.getMonth() + 1}. ${dt.getFullYear()}`}&nbsp;&nbsp;{`${hour}:${min}`}</span>;
}

// d. M. yyyy
export function toStandardDmySpan(dt) {
    if (!dt)
        return '';
    dt = toDate(dt);

    return <span>{`${dt.getDate()}. ${dt.getMonth() + 1}. ${dt.getFullYear()}`}</span>;
}

// ddd HH:mm
export function toDddHhMm (dt) {
    if (!dt)
        return '';
    dt = toDate(dt);

    let day = days[dt.getDay()];
    let hour = `${dt.getHours()}`.padStart(2, '0');
    let min = `${dt.getMinutes()}`.padStart(2, '0');
    return `${day} ${hour}:${min}`;    
}

export function prevDay(value) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate() - 1);
}

export function nextDay(value) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate() + 1);
}

export function prevYear(value) {
    return new Date(value.getFullYear() - 1, value.getMonth(), value.getDate());
}

export function nextYear(value) {
    return new Date(value.getFullYear() + 1, value.getMonth(), value.getDate());
}

export function today() {
    let now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

/* Vraci datum, ktere je o n dni vetsi nez datum d. */
export function addDay(d, n) {
    d = new Date(d);
    var diff = d.getDate() + n;
    return new Date(d.setDate(diff));
}